const WORDS = ["Protection Redefined", "Legacy Secured", "Future Proofed", "Independently Brokered"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="marquee" className="relative py-8 border-y border-white/10 bg-[#0a0a0a] overflow-hidden">
      <div className="flex w-max animate-marquee">
        {row.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="serif italic text-4xl lg:text-6xl text-[#f4f0ea]/90 px-10 whitespace-nowrap">{w}</span>
            <span className="text-[#d4af37] text-2xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
